export default __webpack_public_path__ + "static/media/team33.986e5ab3.JPG";